import { memo } from 'react';

import APIIcon from '@/assets/custom-code-icon.svg?react';
import GoogleDriveIcon from '@/assets/google-drive-logo.svg?react';
import MakeIcon from '@/assets/make-logo.svg?react';
import ManualIcon from '@/assets/manual-icon.svg?react';
import MicrosoftOneDriveIcon from '@/assets/microsoft-one-drive-logo.svg?react';
import N8NIcon from '@/assets/n8n-logo.svg?react';
import PowerAutomateIcon from '@/assets/power-automate-logo.svg?react';
import DefaultTriggerIcon from '@/assets/trigger-icon.svg?react';
import ZapierIcon from '@/assets/zapier-logo.svg?react';
import { merge } from '@/components';
import {
  CREATE_AGENT_RUN_FROM_API_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_GOOGLE_DRIVE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MAKE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MANUAL_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MICROSOFT_ONE_DRIVE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_N8N_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID,
} from '@/constants';
import { SVGProps } from '@/utils';

import { EmailFilledIcon } from './EmailFilledIcon';

export type TriggerIconProps = SVGProps & {
  functionId?: string;
};

const ITriggerIcon = ({ functionId, className, ...rest }: TriggerIconProps) => {
  /* prettier-ignore */
  const styles = [
    'size-4',
  ];

  switch (functionId) {
    case CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID:
      return <EmailFilledIcon className={merge(styles, className)} {...rest} />;
    case CREATE_AGENT_RUN_FROM_MANUAL_FUNCTION_ID:
      return <ManualIcon className={merge(styles, className)} {...rest} />;
    case CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID:
      return <ZapierIcon className={merge(styles, className)} {...rest} />;
    case CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID:
      return <PowerAutomateIcon className={merge(styles, className)} {...rest} />;
    case CREATE_AGENT_RUN_FROM_MAKE_FUNCTION_ID:
      return <MakeIcon className={merge(styles, className)} {...rest} />;
    case CREATE_AGENT_RUN_FROM_N8N_FUNCTION_ID:
      return <N8NIcon className={merge(styles, className)} {...rest} />;
    case CREATE_AGENT_RUN_FROM_API_FUNCTION_ID:
      return <APIIcon className={merge(styles, className)} {...rest} />;
    case CREATE_AGENT_RUN_FROM_MICROSOFT_ONE_DRIVE_FUNCTION_ID:
      return <MicrosoftOneDriveIcon className={merge(styles, className)} {...rest} />;
    case CREATE_AGENT_RUN_FROM_GOOGLE_DRIVE_FUNCTION_ID:
      return <GoogleDriveIcon className={merge(styles, className)} {...rest} />;
  }

  return <DefaultTriggerIcon {...rest} />;
};

export const TriggerIcon = memo(ITriggerIcon) as typeof ITriggerIcon;
